// src/pages/SharePreviewPage.tsx
import React from "react";
import { ShareCard } from "@/components/share/ShareCard";
import { getRandomShareBackground } from "@/components/share/shareBackgrounds";
import { useTranslation } from "react-i18next";

export default function SharePreviewPage() {
  const { t } = useTranslation();
  const bg = getRandomShareBackground();

  const fakeText =
    '“I felt a little small when my idea was ignored in the meeting, ' +
    "but I chose to stay with the feeling instead of running away. " +
    'It was uncomfortable, but it also reminded me that my voice matters.”';

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <ShareCard
        backgroundImage={bg}
        title={t("home.title", { defaultValue: "Inner Gem · Today’s Gem" })}
        subtitle={t("home.subtitle", { defaultValue: "One honest note from today" })}
        mainText={fakeText}
        tagline={t("gem.shareTagline", { defaultValue: "Your awareness today is already a step toward 5D." })}
      />
    </div>
  );
}
